import { Application } from "./scripts/Application";
// import { PixiPlugin } from "gsap/all";
// const pixiPlugin = PixiPlugin;

const canvasDiv = document.createElement("div");
canvasDiv.setAttribute("id", "gameTarget");
document.body.appendChild(canvasDiv);
canvasDiv.appendChild(Application.instance.view);

Application.instance.init();
